import React from 'react';
import { Image } from '@cian/ui-kit/image';

import { IMedia } from '../../../../../packages/Carousel/shared/types/media';

import styles from './Thumbnail.css';

interface IThumbnailProps {
  media: IMedia | null;
}

export const Thumbnail: React.FC<IThumbnailProps> = ({ media, children }) => {
  return (
    <div className={styles['thumbnail']}>
      <Image src={media ? media.url : ''} />
      {children}
    </div>
  );
};
